<template>
  <div>
    <b-loading
      :is-full-page="true"
      :active.sync="isFetchingSavedInfo"
      :can-cancel="false"
    ></b-loading>
    <div class="level">
      <div class="level-left">
        <h4 class="title is-4">
          {{ createOrUpdate }}
        </h4>
      </div>
      <div class="level-right">
        <!-- <button
          v-if="createOrUpdate === 'Manage Billing'"
          class="button is-small is-danger"
          @click="deleteBilling"
        >
          Delete
        </button> -->
        &nbsp;
        <router-link
          :to="{
            name: 'List of Billing',
            params: { page: 1, pageSize: 10 }
          }"
          class="button is-small"
          >View list</router-link
        >&nbsp;
        <button class="button is-small" @click="goBack">Go back</button>
      </div>
    </div>
    <hr />
    <div class="columns">
      <div class="column is-1">
        <div class="field">
          <label class="label is-small">Choose type</label>
          <div class="control">
            <label class="radio">
              <input
                type="radio"
                v-model="siOrDr"
                value="0"
                name="si"
                :disabled="createOrUpdate === 'Manage Billing'"
                @change="siOrDrOnChange($event)"
              />
              <span style="font-size:13px;">S.I</span>
            </label>
            &nbsp;
            <label class="radio">
              <input
                type="radio"
                v-model="siOrDr"
                value="1"
                name="dr"
                @change="siOrDrOnChange($event)"
                :disabled="createOrUpdate === 'Manage Billing'"
              />
              <span style="font-size:13px;">D.R</span>
            </label>
          </div>
        </div>
      </div>
      <!-- <div
        class="column is-2"
        v-if="isShowSi && createOrUpdate !== 'Manage Billing'"
      >
        <div class="field">
          <label class="label is-small">S.I #</label>
          <div class="control">
            <b-autocomplete
              id="searchClientPo"
              v-model="siNum"
              size="is-small"
              :data="siNums"
              placeholder="Search S.I #"
              @select="option => (selectedsiNum = option)"
              @input="searchSiOrDrNums"
              :loading="isFetchingsiNum"
            >
              <template slot="empty">
                <span v-if="isFetchingsiNum">Please wait...</span>
                <span v-if="siNums.length === 0">No results found</span>
              </template>
            </b-autocomplete>
          </div>
        </div>
      </div> -->
      <div class="column is-2" v-if="createOrUpdate === 'Manage Billing'">
        <div class="field">
          <label class="label is-small">{{
            siOrDr === 0 ? "S.I #" : "D.R #"
          }}</label>
          <div class="control">
            <input
              type="text"
              v-model="dataForViewing.siOrDrNum"
              class="input is-small"
              disabled
            />
          </div>
        </div>
      </div>
      <div class="column is-2" v-if="createOrUpdate === 'Manage Billing'">
        <div class="field">
          <label class="label is-small">{{
            siOrDr === 0 ? "S.I Date" : "D.R Date"
          }}</label>
          <div class="control">
            <input
              type="date"
              v-model="dataForViewing.siOrDrDate"
              class="input is-small"
              disabled
            />
          </div>
        </div>
      </div>
      <!-- <div
        class="column is-2"
        v-if="isShowDr && createOrUpdate !== 'Manage Billing'"
      >
        <div class="field">
          <label class="label is-small">D.R #</label>
          <div class="control">
            <b-autocomplete
              id="searchClientPo"
              v-model="drNum"
              size="is-small"
              :data="drNums"
              placeholder="Search here"
              @select="option => (selecteddrNum = option)"
              @input="searchSiOrDrNums"
              :loading="isFetchingsiNum"
            >
              <template slot="empty">
                <span v-if="isFetchingdrNum">Please wait...</span>
                <span v-if="drNums.length === 0">No results found</span>
              </template>
            </b-autocomplete>
          </div>
        </div>
      </div> -->
      <div class="column is-1" v-if="createOrUpdate !== 'Manage Billing'">
        <div class="field">
          <label class="label is-small">Client P.O #</label>
          <div class="control">
            <div class="select is-small">
              <select v-model="selectedClientPoId" :disabled="isFetchingPoIds">
                <option
                  v-for="poNum in poNumbers"
                  :value="poNum.id"
                  :key="poNumber.id"
                  >{{ poNum.name }}</option
                >
              </select>
            </div>
          </div>
        </div>
      </div>
      <div class="column is-2" v-else>
        <div class="field">
          <label class="label is-small">Client P.O #</label>
          <div class="control">
            <input
              type="text"
              v-model="dataForViewing.clientPo"
              class="input is-small"
              disabled
            />
          </div>
        </div>
      </div>
      <div class="column is-3">
        <div class="field">
          <label class="label is-small">Client</label>
          <div class="control">
            <input
              type="text"
              v-model="clientName"
              class="input is-small"
              disabled
            />
          </div>
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column is-6">
        <b-table :data="products" :loading="isLoadingProducts">
          <template slot-scope="item">
            <b-table-column
              class="table-column-content-is-small"
              label="PRODUCT"
              v-if="item.row.productName !== ''"
              >{{ item.row.productName }}
            </b-table-column>
          </template>
        </b-table>
        <div v-if="products.length === 0">
          <i>No products found</i>
        </div>
      </div>
      <div class="column is-6">
        <div class="columns">
          <div class="column is-6">
            <div class="field">
              <label class="label is-small">S.I/D.R Attachment</label>
              <div class="control">
                <input
                  ref="inputFile"
                  type="file"
                  class="input is-small"
                  multiple
                  @change="fileChange($event.target.files)"
                />
              </div>
            </div>
          </div>
          <div class="column is-6">
            <div class="field">
              <label class="label is-small">&nbsp;</label>
              <div class="control">
                <button
                  :class="buttonAddAttachment"
                  @click="addBillingAttachment"
                >
                  Add
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="columns">
          <div class="column">
            <b-table
              :data="billingAttachments"
              :loading="isLoadingBillingAttachment"
            >
              <template slot-scope="item">
                <b-table-column
                  class="table-column-content-is-small"
                  label="Filename"
                  v-if="item.row.filename !== ''"
                  ><p
                    v-if="isRemovingBillingAttachment"
                    style="font-size: 11px"
                  >
                    <i>Please wait...</i>
                  </p>
                  <div class="tags has-addons" v-else>
                    <a
                      class="tag"
                      :title="`View ${item.row.filename}`"
                      @click="
                        downloadBillingAttachment(
                          item.row.billingAttachmentId,
                          item.row.filename
                        )
                      "
                      ><span class="has-text-link">{{
                        item.row.filename
                      }}</span></a
                    >
                    <a
                      class="tag is-delete"
                      title="Delete attachment"
                      @click="
                        removeBillingAttachment(item.row.billingAttachmentId)
                      "
                    ></a>
                  </div>
                </b-table-column>
                <b-table-column
                  class="table-column-content-is-small"
                  label="Date added"
                  >{{ item.row.dateAdded | formatDate }}
                </b-table-column>
              </template>
            </b-table>
            <div v-if="billingAttachments.length === 0">
              <i>No attachment found</i>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="is-divider" data-content="PAYMENT HISTORY"></div>
    <div class="columns" v-if="createOrUpdate === 'Manage Billing'">
      <div class="column is-12">
        <button
          class="button is-small is-info"
          :disabled="products.length <= 0"
          @click="openBillingPayment"
        >
          Add Payment
        </button>
      </div>
    </div>
    <div v-if="payments.length === 0 && createOrUpdate === 'Manage Billing'">
      <i>No payments found</i>
    </div>
    <b-table
      v-else
      :data="payments"
      :loading="isLoadingPayments"
      bordered="true"
      striped="true"
      narrowed="true"
      hoverable="true"
    >
      <template slot-scope="item">
        <b-table-column class="table-column-content-is-small" label="NOTE"
          >{{ item.row.note }}
        </b-table-column>
        <b-table-column
          class="table-column-content-is-small"
          label="DATE OF PAYMENT"
          >{{ item.row.dateOfPayment | formatDate }}
        </b-table-column>
        <b-table-column
          class="table-column-content-is-small"
          label="PAYMENT METHOD"
        >
          <span v-if="item.row.paymentMethod === 0">CASH</span>
          <span v-if="item.row.paymentMethod === 1">CHECK</span>
          <span v-if="item.row.paymentMethod === 2">DEBIT/CREDIT CARD</span>
          <span v-if="item.row.paymentMethod === 3">BANK DEPOSIT</span>
          <span v-if="item.row.paymentMethod === 4"
            >WIRE TRANSFER (e.g. Gcash, PayMaya etc.)</span
          >
        </b-table-column>
        <b-table-column class="table-column-content-is-small" label="AMOUNT"
          >{{ item.row.amount | formatNumber }}
        </b-table-column>
        <b-table-column
          class="table-column-content-is-small"
          label="WITHHOLDING TAX"
          >{{ item.row.withholdingTax | formatNumber }}
        </b-table-column>
        <b-table-column class="table-column-content-is-small" label="TOTAL"
          >{{ (item.row.amount + item.row.withholdingTax) | formatNumber }}
        </b-table-column>
        <b-table-column
          class="table-column-content-is-small"
          label="PROOF OF PAYMENTS"
          ><span v-for="file in item.row.filenames" :key="file.id">
            <div class="field is-grouped is-grouped-multiline">
              <div class="control">
                <p v-if="isRemovingAttachment" style="font-size: 11px">
                  <i>Please wait...</i>
                </p>
                <div class="tags has-addons" v-else>
                  <a
                    class="tag"
                    :title="`View ${file.filename}`"
                    @click="
                      downloadBillingPaymentAttachment(file.id, file.filename)
                    "
                    ><span class="has-text-link">{{ file.filename }}</span></a
                  >
                  <a
                    class="tag is-delete"
                    title="Delete attachment"
                    @click="removeAttachment(file.id)"
                  ></a>
                </div>
              </div>
            </div>
          </span>
        </b-table-column>
        <b-table-column class="table-column-content-is-small" label="">
          <button
            class="button is-warning is-small"
            @click="
              editPayment({
                billingPaymentId: item.row.billingPaymentId,
                billingId: item.row.billingId,
                amount: item.row.amount,
                withholdingTax: item.row.withholdingTax,
                dateOfPayment: item.row.dateOfPayment,
                paymentMethod: item.row.paymentMethod,
                note: item.row.note
              })
            "
          >
            Edit
          </button>
          &nbsp;
          <button
            :class="buttonDeletePayment"
            @click="deletePayment(item.row.billingPaymentId)"
          >
            Remove
          </button>
        </b-table-column>
      </template>
    </b-table>
    <br />
    <h5 class="title is-5">Total</h5>
    <div class="notification">
      <loading
        :active.sync="isLoadingTotal"
        color="#3BAFDA"
        :can-cancel="false"
        :is-full-page="isFullPage"
      ></loading>
      <div class="level">
        <div class="level-left"></div>
        <div class="level-right">
          <div class="column is-12">
            <div class="field">
              <label class="label is-small">SELLING AMOUNT</label>
              <div class="control">
                <h4 class="title is-4">
                  <div v-if="createOrUpdate === 'Manage Billing'">
                    {{ billing.sellingAmount | formatNumber }}
                  </div>
                  <div v-else>
                    <span v-if="products.length > 0">{{
                      products[0].sellingAmount | formatNumber
                    }}</span>
                    <span v-else>0</span>
                  </div>
                </h4>
              </div>
            </div>
          </div>
          <div class="column is-12">
            <div class="field">
              <label class="label is-small">PAID</label>
              <div class="control">
                <h4 class="title is-4">
                  {{ total.paid | formatNumber }}
                </h4>
              </div>
            </div>
          </div>
          <div class="column is-12">
            <div class="field">
              <label class="label is-small">BALANCE</label>
              <div class="control">
                <h4 class="title is-4">
                  {{ total.balance | formatNumber }}
                </h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="level">
      <div class="level-left"></div>
      <div class="level-right">
        <button
          v-if="createOrUpdate !== 'Manage Billing'"
          :class="buttonSave"
          @click="saveAndSend(false)"
        >
          Save
        </button>
        <!-- &nbsp;
        <button :class="buttonSave" @click="saveAndSend(true)">
          Save & send
                </button>-->
        &nbsp;
        <router-link
          :to="{
            name: 'List of Billing',
            params: { page: 1, pageSize: 10 }
          }"
          class="button is-small"
          >View list</router-link
        >&nbsp;
        <button class="button is-small" @click="goBack">Go back</button>
      </div>
    </div>
    <AddEditBilling />
  </div>
</template>

<script>
import Vue from "vue";
import { mapState, mapActions } from "vuex";
import Loading from "vue-loading-overlay";
import axios from "axios";
import moment from "moment";
import numeral from "numeral";
import AppToast from "../frontend/appToast";
import AppButton from "../frontend/appButton";
import AddEditBilling from "./AddEditBilling.vue";
import _ from "lodash";
const isImage = require("is-image");

Vue.filter("formatNumber", function(value) {
  return numeral(value).format("0,0.00"); // displaying other groupings/separators is possible, look at the docs
});

Vue.filter("formatDate", function(value) {
  return moment(value).format("MM/DD/YYYY"); // displaying other groupings/separators is possible, look at the docs
});

const appToast = new AppToast();
const appButton = new AppButton();

export default {
  components: {
    Loading,
    AddEditBilling
  },
  computed: {
    ...mapState("billing", {
      showAddEditBillingModal: state => state.showAddEditBillingModal
    })
  },
  data: () => ({
    isFetchingSavedInfo: false,
    isRemovingAttachment: false,
    isRemovingBillingAttachment: false,
    total: {
      paid: 0,
      balance: 0
    },
    isShowSi: true,
    isShowDr: false,
    siOrDr: 0,
    products: [],
    payments: [],
    isLoadingProducts: false,
    isLoadingPayments: false,
    poNumber: "",
    createOrUpdate: "Create ",
    addOrEditToTable: "Add",
    files: new FormData(),
    purchaseOrder: {
      purchaseOrderId: 0,
      poNum: 0,
      supplierId: 0,
      emails: "",
      cc: "",
      bcc: "",
      poStatus: 0,
      mailingAddress: "",
      shipTo: "",
      shippingAddress: "",
      shipVia: "",
      poDate: null,
      cvNo: "",
      checkNo: "",
      oldPoNum: "",
      messageToSupplier: "",
      purchaseOrderDetails: []
    },
    billing: {
      billingId: 0,
      siNum: "",
      siDate: null,
      drNum: "",
      drDate: null,
      siOrDr: 0,
      deliveryId: 0,
      poRequestId: 0,
      billingDetails: []
    },
    // search si
    siNum: "",
    siNums: [],
    selectedsiNum: 0,
    selectedsiNumForEdit: {},
    isFetchingsiNum: false,
    // search dr
    drNum: "",
    drNums: [],
    selecteddrNum: 0,
    selecteddrNumForEdit: {},
    isFetchingdrNum: false,
    billingAttachments: [],
    // getPoNumbers by selected SI
    poNumbers: [],
    // getClient name by selected P.O
    clientName: "Please select S.I/D.R # and Client P.O",
    // ids
    selectedClientPoId: 0,
    isFetchingPoIds: false,
    // loadings
    isLoadingTable: false,
    isLoadingBillingAttachment: false,
    isLoadingTotal: false,
    isFullPage: false,
    dataForViewing: {
      siOrDrNum: "",
      siOrDrDate: null,
      clientPo: ""
    },
    // buttons
    buttonDeletePayment: appButton.isLoadingDangerInverted(false),
    buttonSave: appButton.isLoadingSuccess(false),
    buttonAddAttachment: appButton.isLoadingInfo(false),
    buttonSaveAndSend: appButton.isLoadingSuccess(false),
    buttonDownloadPoRequest: appButton.isLoadingDefault(false)
  }),
  created() {
    const billingId = this.$route.params.billingId;
    if (billingId) {
      this.getBillingById(billingId);
      this.getBillingPaymentByBillingId(billingId);
    } else {
      // CREATE Mode
      this.getCurrentDateFromServer();
    }
  },
  methods: {
    ...mapActions("productorservice", [
      "openCreateEditModal",
      "clearSelectedPurchaseOrderState"
    ]),
    ...mapActions("billing", ["openAddEditBillingModal"]),
    searchSiOrDrNums() {
      let valueToSearch = "";
      if (this.siOrDr === 0) {
        valueToSearch = this.siNum;
      } else {
        valueToSearch = this.drNum;
      }
      if (valueToSearch) {
        const isSi = this.siOrDr === 0 ? true : false;
        axios
          .get(
            `api/searchqueries/delivery-by-si-or-dr/${isSi}/${valueToSearch}`
          )
          .then(response => {
            if (isSi) this.siNums = response.data;
            else this.drNums = response.data;
          })
          .catch(error => console.log(error));
      }
    },
    addBillingAttachment() {
      this.buttonAddAttachment = appButton.isLoadingInfo(true);
      axios
        .patch(
          `api/billings/add-attachment/${this.billing.billingId}`,
          this.files
        )
        .then(response => {
          appToast.success(response.data);
          this.buttonAddAttachment = appButton.isLoadingInfo(false);
          this.getBillingAttachments(this.billing.billingId);
          this.$refs.inputFile.value = null;
          this.$refs.inputFile.value = "";
          this.files = new FormData();
        })
        .catch(error => {
          if (error.response) {
            appToast.danger(error.response.data);
          }
          this.buttonAddAttachment = appButton.isLoadingInfo(false);
        });
    },
    downloadBillingPaymentAttachment(id, filename) {
      if (id) {
        axios
          .get(`downloadables/DownloadBillingPaymentAttachment/${id}`, {
            responseType: "blob"
          })
          .then(response => {
            let url = window.URL.createObjectURL(response.data);
            if (isImage(filename)) {
              window.open(url, "_blank");
            } else {
              url = window.URL.createObjectURL(new Blob([response.data]));
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", filename);
              document.body.appendChild(link);
              link.click();
            }
          })
          .catch(error => {
            console.log(error);
            appToast.danger("Something went wrong. Failed to download.");
          });
      }
    },
    downloadBillingAttachment(id, filename) {
      if (id) {
        axios
          .get(`downloadables/DownloadBillingAttachment/${id}`, {
            responseType: "blob"
          })
          .then(response => {
            let url = window.URL.createObjectURL(response.data);
            if (isImage(filename)) {
              window.open(url, "_blank");
            } else {
              url = window.URL.createObjectURL(new Blob([response.data]));
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", filename);
              document.body.appendChild(link);
              link.click();
            }
          })
          .catch(error => {
            console.log(error);
            appToast.danger("Something went wrong. Failed to download.");
          });
      }
    },
    editPayment(data) {
      this.openAddEditBillingModal({
        showAddEditBillingModal: true,
        billingPayment: data
      });
    },
    deletePayment(id) {
      const confirmAlert = window.confirm(
        "Are you sure do you want to delete this payment?"
      );

      if (confirmAlert) {
        if (id) {
          this.buttonDeletePayment = appButton.isLoadingDangerInverted(true);
          axios
            .delete(`api/billings/delete-payment/${id}`)
            .then(response => {
              appToast.success(response.data);
              this.getBillingPaymentByBillingId(this.billing.billingId);
              this.buttonDeletePayment = appButton.isLoadingDangerInverted(
                false
              );
            })
            .catch(error => {
              console.log(error);
              appToast.danger("Something went wrong. Failed to delete.");
              this.buttonDeletePayment = appButton.isLoadingDangerInverted(
                false
              );
            });
        }
      }
    },
    removeAttachment(id) {
      const confirmAlert = window.confirm(
        "Are you sure do you want to delete this attachment?"
      );

      if (confirmAlert) {
        if (id) {
          this.isRemovingAttachment = true;
          axios
            .delete(`api/billings/delete-attachment/${id}`)
            .then(response => {
              appToast.success(response.data);
              this.isRemovingAttachment = false;
              this.getBillingPaymentByBillingId(this.billing.billingId);
            })
            .catch(error => {
              console.log(error);
              appToast.danger("Something went wrong. Failed to remove.");
              this.isRemovingAttachment = false;
            });
        }
      }
    },
    removeBillingAttachment(id) {
      const confirmAlert = window.confirm(
        "Are you sure do you want to delete this billing attachment?"
      );

      if (confirmAlert) {
        if (id) {
          this.isRemovingBillingAttachment = true;
          axios
            .delete(`api/billings/delete-billing-attachment/${id}`)
            .then(response => {
              appToast.success(response.data);
              this.isRemovingBillingAttachment = false;
              this.getBillingAttachments(this.billing.billingId);
            })
            .catch(error => {
              console.log(error);
              appToast.danger("Something went wrong. Failed to remove.");
              this.isRemovingBillingAttachment = false;
            });
        }
      }
    },
    deleteBilling() {
      // const confirmAlert = window.confirm(
      //   "Are you sure do you want to delete this transaction?"
      // );
      // if (confirmAlert) {
      //   this.isLoadingTotal = true;
      //   axios
      //     .delete(`api/billings/${this.billing.billingId}`)
      //     .then(response => {
      //       appToast.success(response.data);
      //       this.isLoadingTotal = false;
      //       this.$router.push({
      //         name: "List of Billing",
      //         params: { page: 1, pageSize: 10 }
      //       });
      //     })
      //     .catch(error => {
      //       if (error.response) {
      //         appToast.danger(error.response.data);
      //       }
      //       this.isLoadingTotal = false;
      //     });
      // }
    },
    openBillingPayment() {
      this.openAddEditBillingModal({
        showAddEditBillingModal: true
      });
    },
    goBack() {
      this.$router.go(-1);
    },
    getCurrentDateFromServer() {
      this.isFetchingSavedInfo = true;
      axios
        .get(`api/settings/current-date`)
        .then(response => {
          this.delivery.deliveryDate = moment(response.data).format(
            "YYYY-MM-DD"
          );
        })
        .catch(error => console.log(error))
        .then(() => {
          this.isFetchingSavedInfo = false;
        });
    },
    fileChange(fileList) {
      for (let i = 0; i < fileList.length; i++) {
        this.files.append("files", fileList[i], fileList[i].name);
      }
    },
    getBillingById(id) {
      this.isFetchingSavedInfo = true;
      this.createOrUpdate = "Manage Billing";
      axios
        .get(`api/billings/${id}`)
        .then(response => {
          this.getBillingAttachments(response.data.billingId);
          this.billing = response.data;
          this.products = this.billing.billingDetails;
          this.clientName = response.data.clientName;
          this.siOrDr = this.billing.siNum ? 0 : 1;
          this.dataForViewing = {
            siOrDrNum:
              this.siOrDr == 0 ? this.billing.siNum : this.billing.drNum,
            siOrDrDate:
              this.siOrDr == 0
                ? moment(this.billing.siDate).format("YYYY-MM-DD")
                : moment(this.billing.drDate).format("YYYY-MM-DD"),
            clientPo: response.data.clientPo
          };
        })
        .catch(error => {
          console.log(error);
        })
        .then(() => {
          this.isFetchingSavedInfo = false;
        });
    },
    getBillingAttachments(billingId) {
      if (billingId) {
        this.isLoadingBillingAttachment = true;
        axios
          .get(`api/billings/billing-attachments/${billingId}`)
          .then(response => {
            this.billingAttachments = response.data;
            this.isLoadingBillingAttachment = false;
          })
          .catch(error => {
            console.log(error);
            this.isLoadingBillingAttachment = false;
          });
      }
    },
    calculatePaidAndBalance() {
      if (this.payments.length > 0) {
        let paid = 0;
        this.payments.forEach(x => (paid += x.amount + x.withholdingTax));
        this.total = {
          paid: paid,
          balance: Number(this.billing.sellingAmount - paid).toFixed(2)
        };
      } else {
        this.total = {
          paid: 0,
          balance: 0
        };
      }
    },
    downloadPdf(id, poNumber) {
      if (id) {
        this.buttonDownloadPoRequest = appButton.isLoadingDefault(true);
        axios
          .get(`downloadables/purchaseorder?id=${id}`, {
            responseType: "blob"
          })
          .then(response => {
            console.log(response.data);
            const windowUrl = window.URL || window.webkitURL;
            const url = windowUrl.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `PURCHASE ORDER ${poNumber}.pdf`);
            document.body.appendChild(link);
            link.click();
          })
          .catch(error => {
            console.log(error);
          })
          .then(
            () =>
              (this.buttonDownloadPoRequest = appButton.isLoadingDefault(false))
          );
      }
    },
    saveAndSend(isSend) {
      this.buttonSave = appButton.isLoadingSuccess(true);
      // CREATE
      const billingId = this.billing.billingId;
      this.products.forEach(d => {
        this.billing.billingDetails = [
          ...this.billing.billingDetails,
          {
            poRequestDetailId: d.poRequestDetailId,
            billingId: billingId
          }
        ];
      });
      this.billing.deliveryId =
        this.siOrDr === 0 ? this.selectedsiNum.id : this.selecteddrNum.id;
      this.billing.siOrDr = this.siOrDr;
      this.billing.poRequestId = this.selectedClientPoId;
      if (!billingId) {
        axios
          .post(`api/billings/`, this.billing)
          .then(response => {
            appToast.success(response.data.message);
            this.$router.push({
              name: "Edit Billing",
              params: { billingId: response.data.billingId }
            });

            this.getBillingById(response.data.billingId);
          })
          .catch(error => {
            console.log(error);
            if (error.response) {
              appToast.danger(error.response.data);
            }
          })
          .then(() => {
            this.buttonSave = appButton.isLoadingSuccess(false);
          });
      }
    },
    searchClientPoNums() {
      // authService.isLoggedIn() // check login
      axios
        .get(`api/searchqueries/po-request-client-po/${this.clientPoNum}`)
        .then(response => {
          this.clientPoNums = response.data;
        })
        .catch(error => console.log(error));
    },
    checkIfValIsValidNumber(number) {
      return !number ? 0 : number;
    },
    getProductsByClientPoAndDeliveryId(deliveryId, poRequestId) {
      if (deliveryId && poRequestId) {
        this.isLoadingProducts = true;
        axios
          .get(`api/billings/products-for-billing/${deliveryId}/${poRequestId}`)
          .then(response => {
            this.products = response.data;
            this.isLoadingProducts = false;
          })
          .catch(error => {
            console.log(error);
            this.isLoadingProducts = false;
          });
      }
    },
    getBillingPaymentByBillingId(billingId) {
      if (billingId) {
        this.isLoadingPayments = true;
        axios
          .get(`api/billings/billing-payments/${billingId}`)
          .then(response => {
            this.payments = response.data;
            this.isLoadingPayments = false;
          })
          .catch(error => {
            console.log(error);
            this.isLoadingPayments = false;
          });
      }
    },
    siOrDrOnChange(e) {
      if (e.srcElement.name === "si") {
        this.isShowSi = true;
        this.isShowDr = false;
      } else {
        this.isShowSi = false;
        this.isShowDr = true;
      }
      // this.clearSelectedFormAndResult();
    },
    getClientPoNumbers(val) {
      this.isFetchingPoIds = true;
      axios
        .get(`api/billings/get-client-po-number-by-delivery-id/${val}`)
        .then(response => {
          this.poNumbers = response.data;
          this.isFetchingPoIds = false;
        })
        .catch(error => {
          console.log(error);
          this.isFetchingPoIds = false;
        });
    },
    clearSelectedFormAndResult() {
      this.selectedClientPoId = 0;
      this.selectedClientId = 0;
      this.poNumbers = [];
      this.siNum = "";
      this.drNum = "";
      this.selectedsiNum = 0;
      this.selecteddrNum = 0;
    }
  },
  watch: {
    payments() {
      this.calculatePaidAndBalance();
    },
    billing() {
      this.calculatePaidAndBalance();
    },
    showAddEditBillingModal() {
      this.getBillingPaymentByBillingId(this.billing.billingId);
    },
    selectedsiNum() {
      this.getClientPoNumbers(this.selectedsiNum.id);
    },
    selecteddrNum() {
      this.getClientPoNumbers(this.selecteddrNum.id);
    },
    selectedClientPoId() {
      if (this.selectedClientPoId) {
        this.clientName = "...";
        axios
          .get(
            `api/porequests/client-and-client-po-by-porequest/${
              this.selectedClientPoId
            }`
          )
          .then(response => {
            this.clientName = response.data.client;
          })
          .catch(error => {
            console.log(error);
            this.clientName = "Please select S.I/D.R # and Client P.O";
          });

        this.getProductsByClientPoAndDeliveryId(
          this.siOrDr === 0 ? this.selectedsiNum.id : this.selecteddrNum.id,
          this.selectedClientPoId
        );
      }
    }
  }
};
</script>
